/* ============================================================
   SOLENNE — cart upsell loader (built on Dawn). Self-contained.
   Fetches the Recommendations-API-backed section via the Section Rendering
   API and injects it. Falls back to the curated collection server-side.
   ============================================================ */
(function () {
  'use strict';

  class SlnCartUpsell extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      const url = this.dataset.url;
      if (!url) return;

      fetch(url)
        .then((res) => {
          if (!res.ok) throw new Error('upsell fetch failed');
          return res.text();
        })
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const content = doc.querySelector('.sln-cart-upsell');
          if (content && content.innerHTML.trim()) {
            this.innerHTML = content.innerHTML;
          } else {
            this.remove();
          }
        })
        .catch((error) => {
          console.warn('sln cart upsell failed', error);
          this.remove();
        });
    }
  }

  customElements.define('sln-cart-upsell', SlnCartUpsell);
})();
